var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009543",
    d: "M.7 28H54v12H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00209f",
    d: "M.7 0H54v12H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "m27.3 12.8-.5.2v2.7l-.8.9h.7V18l-4 5.5-.7-.2-1 2.3s2.6 1.6 6.4 1.6c4.1 0 6.4-1.7 6.4-1.7l-1.1-2.2-.6.2-4-5.5v-1.6h.6l-1-.8V13q0-.2-.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M28.7 19.2H26s-1-2.2-.9-3.7q.3-2.2 2.3-2.2 1.9-.1 2.3 2.2c.2 1.5-.9 3.7-.9 3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.4 24.3-.4.8.6-.1zm.3 1-.6.1.7.3zm.3-1 .3 1 .7-.2-.2-.5zm.5 1.3v.4l1 .2-.3-.8zm1-.8.4.9.8-.3-.3-.4zm.6 1.2v.3l1.2.2-.4-.8zm1-1 .5.8 1.1-.4-.1-.3zm.7 1 .2.5h1.4l-.5-.8zm1.4-1 .4.7.9-.4-.3-.3zm1.5.6-.9.4.2.4 1.2-.2zm.2-.7.5.6.7-.6-.3-.3zm1.4.3-.7.5.1.4 1-.3zm1-1v.2l-.4.7-.5-.7zm.2.5.3.6-.6.2v-.3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLs);
export default __webpack_public_path__ + "static/media/ls.eba6a96f9c37fd3c4102bf7edd3d824d.svg";
export { ForwardRef as ReactComponent };